module.exports = __webpack_public_path__ + "img/ic_dissatisfied_grey.4891d518.svg";